import { VehicleCategory } from '../../../../../core/services/application.model';
import { NoValue } from '@tribeauto/ngx-mobilite-material';

export interface DematDeliveryData {
  registrationNumber: string;
  distanceSignature: boolean;
  emailAddress: string;
  mobilePhoneNumber: string;
  serialNumber: string;
}

export const DEFAULT_DEMAT_DELIVERY = {
  registrationNumber: '',
  distanceSignature: false,
  emailAddress: '',
  mobilePhoneNumber: '',
  serialNumber: ''
};

export type DematDeliveryContractData = {
  emailAddress: string;
  mobilePhoneNumber: string;
  vehicleCategory: VehicleCategory;
  registrationNumber?: string;
  serialNumber: string;
  usedVehicle: boolean;
  holderName: string;
  import: boolean;
};

export type DeliveryRequest = {
  distanceSignature: boolean;
  holder: {
    contactData: {
      emailAddress: string;
      mobilePhoneNumber: string;
    };
  };
  project: {
    vehicle: {
      registrationNumber: string | NoValue;
      serialNumber: string;
    };
  };
};

export type DeliveryResponse = {
  esignUrl: string;
};

export type FinancingRequest = {
  holder: FinanceHolderRequest;
  vehicle: FinanceVehicleRequest;
};

export type FinanceHolderRequest = {
  dopc: boolean;
  gdpr: boolean;
  optIn: boolean;
};

export type FinanceVehicleRequest = {
  importedVehicle: boolean;
  registrationNumber: string;
  serialNumber: string;
};
